/* Pure Meubels theme — vanilla JS, no dependencies. */
(() => {
  'use strict';

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');
  const fetchJSON = (url, body) =>
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(async (res) => {
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || theme.strings.cartError);
      return data;
    });

  /* Header -------------------------------------------------------------- */
  const header = $('[data-header]');

  function measureHeader() {
    if (!header) return;
    const rect = header.getBoundingClientRect();
    const root = document.documentElement.style;
    root.setProperty('--header-h', `${Math.round(rect.height)}px`);
    root.setProperty('--header-bottom', `${Math.max(Math.round(rect.bottom), 0)}px`);
  }

  function initHeader() {
    if (!header) return;
    measureHeader();
    window.addEventListener('resize', measureHeader, { passive: true });
    window.addEventListener('scroll', measureHeader, { passive: true });

    const menuToggle = $('[data-menu-toggle]', header);
    const drawer = $('[data-menu-drawer]', header);
    const searchPanel = $('[data-search-panel]', header);

    const setMenu = (open) => {
      measureHeader();
      header.classList.toggle('is-menu-open', open);
      menuToggle?.setAttribute('aria-expanded', String(open));
      drawer?.setAttribute('aria-hidden', String(!open));
      document.body.classList.toggle('is-locked', open);
    };
    menuToggle?.addEventListener('click', () => setMenu(!header.classList.contains('is-menu-open')));

    const setSearch = (open) => {
      if (!searchPanel) return;
      searchPanel.hidden = !open;
      if (open) {
        setMenu(false);
        $('input[type="search"]', searchPanel)?.focus();
      }
    };
    $$('[data-search-toggle]', header).forEach((btn) => btn.addEventListener('click', () => setSearch(searchPanel.hidden)));

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      setMenu(false);
      setSearch(false);
      document.activeElement?.closest('.header__category--mega') && document.activeElement.blur();
    });
    // Judge.me-reviewstrook: klik op een ingekorte review om de hele tekst te lezen.
  document.addEventListener('click', (event) => {
    const body = event.target.closest('.jdgm-review-widget .jm-review-content__body');
    if (body) body.closest('.jm-review-item')?.classList.toggle('is-expanded');
  });

  document.addEventListener('click', (event) => {
      if (searchPanel && !searchPanel.hidden && !event.target.closest('[data-search-panel], [data-search-toggle]')) setSearch(false);
    });

    initPromoBar();
    initPredictiveSearch();
  }

  function initPromoBar() {
    $$('[data-countdown]').forEach((el) => {
      const value = el.dataset.countdown.trim();
      // "23:59" counts down to that time every day; "2026-12-31 23:59" to a fixed moment.
      const daily = value.match(/^(\d{1,2}):(\d{2})$/);
      const nextDaily = () => {
        const target = new Date();
        target.setHours(Number(daily[1]), Number(daily[2]), 0, 0);
        if (target.getTime() <= Date.now()) target.setDate(target.getDate() + 1);
        return target.getTime();
      };
      let end = daily ? nextDaily() : new Date(value.replace(' ', 'T')).getTime();
      if (Number.isNaN(end)) return;
      const tick = () => {
        let diff = end - Date.now();
        if (diff <= 0 && daily) {
          end = nextDaily();
          diff = end - Date.now();
        }
        if (diff <= 0) {
          el.remove();
          return false;
        }
        const d = Math.floor(diff / 864e5);
        const h = Math.floor((diff % 864e5) / 36e5);
        const m = Math.floor((diff % 36e5) / 6e4);
        const s = Math.floor((diff % 6e4) / 1e3);
        const chip = (value, label) => `<span class="promo-bar__chip"><b>${String(value).padStart(2, '0')}</b><small>${label}</small></span>`;
        el.innerHTML = (d > 0 ? chip(d, 'DAGEN') : '') + chip(h, 'UUR') + chip(m, 'MIN') + chip(s, 'SEC');
        return true;
      };
      if (tick()) {
        const timer = setInterval(() => !tick() && clearInterval(timer), 1000);
      }
    });
  }

  function initPredictiveSearch() {
    const form = $('[data-predictive-form]');
    const results = $('[data-predictive-results]');
    if (!form || !results) return;
    const input = $('input[type="search"]', form);
    let timer;
    let controller;

    document.addEventListener('click', (event) => {
      if (!event.target.closest('[data-header-search]')) results.innerHTML = '';
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') results.innerHTML = '';
    });

    input.addEventListener('input', () => {
      clearTimeout(timer);
      const term = input.value.trim();
      if (term.length < 2) {
        results.innerHTML = '';
        return;
      }
      timer = setTimeout(() => {
        controller?.abort();
        controller = new AbortController();
        const url = `${theme.routes.predictiveSearch}?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`;
        fetch(url, { signal: controller.signal })
          .then((res) => (res.ok ? res.text() : ''))
          .then((html) => {
            const section = $('#shopify-section-predictive-search', parseHTML(html));
            results.innerHTML = section ? section.innerHTML : '';
          })
          .catch(() => {});
      }, 250);
    });
  }

  /* Dropdown <details> (filters, sort) ------------------------------------ */
  document.addEventListener('click', (event) => {
    $$('details[data-dropdown][open]').forEach((details) => {
      if (!details.contains(event.target) && !window.matchMedia('(max-width: 749px)').matches) details.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') $$('details[data-dropdown][open]').forEach((details) => details.removeAttribute('open'));
  });

  /* Accordion animation ------------------------------------------------- */
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.accordion > summary');
    if (!summary || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const details = summary.parentElement;
    const content = $('.accordion__content', details);
    if (!content || !content.animate) return;
    event.preventDefault();

    if (details.open) {
      const animation = content.animate({ height: [`${content.offsetHeight}px`, '0px'] }, { duration: 250, easing: 'ease' });
      animation.onfinish = () => details.removeAttribute('open');
    } else {
      details.setAttribute('open', '');
      content.animate({ height: ['0px', `${content.offsetHeight}px`] }, { duration: 250, easing: 'ease' });
    }
  });

  /* Slider -------------------------------------------------------------- */
  class SliderComponent extends HTMLElement {
    connectedCallback() {
      this.track = $('[data-slider-track]', this);
      if (!this.track) return;
      this.prev = $('[data-slider-prev]', this);
      this.next = $('[data-slider-next]', this);
      this.prev?.addEventListener('click', () => this.move(-1));
      this.next?.addEventListener('click', () => this.move(1));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      new ResizeObserver(() => this.update()).observe(this.track);
      this.update();
    }

    move(direction) {
      const item = this.track.firstElementChild;
      if (!item) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: direction * (item.getBoundingClientRect().width + gap), behavior: 'smooth' });
    }

    update() {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      this.classList.toggle('is-scrollable', scrollWidth > clientWidth + 2);
      if (this.prev) this.prev.disabled = scrollLeft <= 2;
      if (this.next) this.next.disabled = scrollLeft + clientWidth >= scrollWidth - 2;
      const media = $('.product-card__media, .collection-card', this.track);
      if (media) this.style.setProperty('--slider-media-h', `${media.offsetHeight}px`);
    }
  }
  customElements.define('slider-component', SliderComponent);

  /* Cart ---------------------------------------------------------------- */
  const cart = {
    drawer: null,
    pendingAttributes: null,

    setCount(count) {
      $$('[data-cart-count]').forEach((el) => (el.textContent = count));
    },

    render(sections, count) {
      if (count !== undefined) this.setCount(count);
      const html = sections && sections['cart-drawer'];
      if (!html || !this.drawer) return;
      const fresh = $('cart-drawer', parseHTML(html));
      if (!fresh) return;
      const panel = $('.cart-drawer__panel', this.drawer);
      const scrollTop = $('.cart-drawer__content', this.drawer)?.scrollTop || 0;
      panel.innerHTML = $('.cart-drawer__panel', fresh).innerHTML;
      this.drawer.dataset.count = fresh.dataset.count;
      const content = $('.cart-drawer__content', this.drawer);
      if (content) content.scrollTop = scrollTop;
    },

    async add(id, quantity = 1, properties = null) {
      const body = { id, quantity, sections: 'cart-drawer' };
      if (properties && Object.keys(properties).length) body.properties = properties;
      // Make sure a just-picked delivery date is saved before the cart moves on to checkout.
      if (this.pendingAttributes) await this.pendingAttributes.catch(() => {});
      const data = await fetchJSON(`${theme.routes.cartAdd}.js`, body);
      if (theme.afterAdd === 'checkout') {
        window.location.href = theme.routes.checkout;
        return;
      }
      if (!this.drawer) {
        window.location.href = theme.routes.cart;
        return;
      }
      const state = await fetch(`${theme.routes.cart}.js`).then((res) => res.json());
      this.render(data.sections, state.item_count);
      this.drawer.open();
    },

    async change(line, quantity) {
      if (!this.drawer) {
        await fetchJSON(`${theme.routes.cartChange}.js`, { line, quantity });
        window.location.reload();
        return;
      }
      this.drawer.classList.add('is-busy');
      try {
        const data = await fetchJSON(`${theme.routes.cartChange}.js`, { line, quantity, sections: 'cart-drawer' });
        this.render(data.sections, data.item_count);
      } finally {
        this.drawer.classList.remove('is-busy');
      }
    },
  };

  class CartDrawer extends HTMLElement {
    connectedCallback() {
      cart.drawer = this;
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-cart-close]')) this.close();
      });
      document.addEventListener('keydown', (event) => event.key === 'Escape' && this.close());
    }

    open() {
      this.lastFocus = document.activeElement;
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-locked');
      $('.cart-drawer__panel', this)?.focus({ preventScroll: true });
    }

    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-locked');
      this.lastFocus?.focus?.({ preventScroll: true });
    }
  }
  customElements.define('cart-drawer', CartDrawer);

  /* Delivery date ------------------------------------------------------- */
  // Dates are handled as UTC midnight so day arithmetic never trips over daylight saving.
  const utcDate = (y, m, d) => new Date(Date.UTC(y, m - 1, d));
  const addDays = (date, days) => new Date(date.getTime() + days * 864e5);
  const isoDate = (date) => date.toISOString().slice(0, 10);

  function dutchHolidays(year) {
    // Easter Sunday (anonymous Gregorian algorithm).
    const a = year % 19, b = Math.floor(year / 100), c = year % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    const easter = utcDate(year, month, day);
    const kingsDay = utcDate(year, 4, 27);
    return [
      utcDate(year, 1, 1),
      addDays(easter, 1),
      kingsDay.getUTCDay() === 0 ? utcDate(year, 4, 26) : kingsDay,
      addDays(easter, 39),
      addDays(easter, 50),
      utcDate(year, 12, 25),
      utcDate(year, 12, 26),
    ].map(isoDate);
  }

  class DeliveryDate extends HTMLElement {
    connectedCallback() {
      // A pre-order is in the cart: no date to choose, and drop a date picked earlier.
      if (this.hasAttribute('data-clear')) {
        cart.pendingAttributes = fetchJSON(`${theme.routes.cart}/update.js`, { attributes: { [this.dataset.attribute]: '', [this.dataset.isoAttribute || 'leverdatum']: '' } });
        cart.pendingAttributes.catch(() => {});
        return;
      }
      this.select = $('[data-delivery-select]', this);
      if (!this.select) return;
      this.closed = new Set((this.dataset.closed || '').split(',').map((value) => value.trim()).filter(Boolean));
      this.build();
      this.select.addEventListener('change', () => this.save());
    }

    isDeliveryDay(date) {
      const weekday = date.getUTCDay();
      if (weekday === 0 || (weekday === 6 && this.dataset.saturday !== 'true')) return false;
      const iso = isoDate(date);
      return !this.closed.has(iso) && !dutchHolidays(date.getUTCFullYear()).includes(iso);
    }

    build() {
      const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
      const get = (type) => Number(parts.find((part) => part.type === type).value);
      const today = utcDate(get('year'), get('month'), get('day'));
      const [cutHour, cutMinute] = (this.dataset.cutoff || '16:00').split(':').map(Number);
      const pastCutoff = get('hour') * 60 + get('minute') >= (cutHour || 0) * 60 + (cutMinute || 0);

      // Earliest date: the given number of delivery days after today, one more after the cut-off time.
      let lead = (Number(this.dataset.lead) || 1) + (pastCutoff ? 1 : 0);
      let first = today;
      while (lead > 0) {
        first = addDays(first, 1);
        if (this.isDeliveryDay(first)) lead -= 1;
      }
      if (this.dataset.earliest) {
        const [y, m, d] = this.dataset.earliest.split('-').map(Number);
        const earliest = utcDate(y, m, d);
        if (earliest > first) first = earliest;
        while (!this.isDeliveryDay(first)) first = addDays(first, 1);
      }

      const long = new Intl.DateTimeFormat('nl-NL', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
      const short = new Intl.DateTimeFormat('nl-NL', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' });
      const asap = this.select.options[0];
      asap.textContent = `${asap.textContent.split(' (')[0]} (vanaf ${short.format(first)})`;

      const last = addDays(first, (Number(this.dataset.weeks) || 2) * 7);
      let group = null;
      let groupMonth = '';
      for (let date = first; date <= last; date = addDays(date, 1)) {
        if (!this.isDeliveryDay(date)) continue;
        const month = new Intl.DateTimeFormat('nl-NL', { timeZone: 'UTC', month: 'long', year: 'numeric' }).format(date);
        if (month !== groupMonth) {
          group = document.createElement('optgroup');
          group.label = month.charAt(0).toUpperCase() + month.slice(1);
          this.select.append(group);
          groupMonth = month;
        }
        const option = document.createElement('option');
        option.value = long.format(date);
        option.dataset.iso = isoDate(date);
        option.textContent = long.format(date).replace(/ \d{4}$/, '');
        group.append(option);
      }

      const current = this.dataset.current;
      if (current && Array.from(this.select.options).some((option) => option.value === current)) this.select.value = current;
    }

    save() {
      const value = this.select.value;
      // Keep every date picker on the page (product page and side cart) in step.
      $$('delivery-date [data-delivery-select]').forEach((select) => {
        if (select !== this.select && Array.from(select.options).some((option) => option.value === value)) select.value = value;
      });
      $$('delivery-date').forEach((el) => { el.dataset.current = value; });
      // Two attributes: readable text for people, an ISO date (JJJJ-MM-DD) for Flow and other integrations.
      const iso = this.select.selectedOptions[0]?.dataset.iso || '';
      cart.pendingAttributes = fetchJSON(`${theme.routes.cart}/update.js`, { attributes: { [this.dataset.attribute]: value, [this.dataset.isoAttribute || 'leverdatum']: iso } });
      cart.pendingAttributes.catch(() => {});
    }
  }
  customElements.define('delivery-date', DeliveryDate);

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-cart-toggle]');
    if (toggle && cart.drawer) {
      event.preventDefault();
      cart.drawer.open();
      return;
    }

    // Size buttons on a grouped product card: switch link, photo, price and quick add to that size.
    const chip = event.target.closest('[data-size-chip]');
    if (chip) {
      event.preventDefault();
      const card = chip.closest('[data-size-card]');
      if (!card) return;
      $$('[data-size-chip]', card).forEach((el) => {
        el.classList.toggle('is-active', el === chip);
        el.setAttribute('aria-pressed', String(el === chip));
      });
      $$('[data-card-link]', card).forEach((link) => { link.href = chip.dataset.url; });
      const price = $('[data-card-price]', card);
      if (price && chip.dataset.price) price.innerHTML = chip.dataset.price;
      const img = $('.product-card__img:not(.product-card__img--hover)', card);
      if (img && chip.dataset.image) {
        img.removeAttribute('srcset');
        img.src = chip.dataset.image;
        // Same fit rules as the card snippet: wide shots and shots narrower than the frame are shown in full.
        const media = img.closest('.product-card__media');
        const ratio = parseFloat(chip.dataset.ratio) || 1;
        const frameRatio = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--card-ratio')) || 1;
        media?.classList.toggle('is-wide', ratio > 1.3);
        media?.classList.toggle('is-tall', ratio <= 1.3 && ratio < frameRatio);
      }
      $('.product-card__img--hover', card)?.remove();
      const quickButton = $('[data-card-quick]', card);
      if (quickButton) {
        quickButton.hidden = !chip.dataset.quick;
        if (chip.dataset.quick) quickButton.dataset.quickAdd = chip.dataset.quick;
      }
      return;
    }

    const quick = event.target.closest('[data-quick-add]');
    if (quick) {
      event.preventDefault();
      quick.classList.add('is-loading');
      cart
        .add(Number(quick.dataset.quickAdd), 1)
        .catch((error) => window.alert(error.message))
        .finally(() => quick.classList.remove('is-loading'));
      return;
    }

    const qty = event.target.closest('[data-cart-qty]');
    if (qty) {
      event.preventDefault();
      const line = Number(qty.closest('[data-line]').dataset.line);
      cart.change(line, Number(qty.dataset.cartQty)).catch((error) => window.alert(error.message));
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    const buttons = $$(`[form="${form.id}"], #${CSS.escape(form.id)} [type="submit"]`);
    const error = $('[data-product-error]', form);
    if (error) error.hidden = true;
    buttons.forEach((button) => button.classList.add('is-loading'));
    const data = new FormData(form);
    const properties = {};
    data.forEach((value, key) => {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && value !== '') properties[match[1]] = value;
    });
    cart
      .add(Number(data.get('id')), Number(data.get('quantity') || 1), properties)
      .catch((err) => {
        if (!error) return;
        error.textContent = err.message;
        error.hidden = false;
      })
      .finally(() => buttons.forEach((button) => button.classList.remove('is-loading')));
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (!button) return;
    const input = $('input', button.closest('[data-quantity]'));
    const step = button.hasAttribute('data-quantity-plus') ? 1 : -1;
    input.value = Math.max(Number(input.min) || 1, (Number(input.value) || 1) + step);
  });

  /* Product page -------------------------------------------------------- */
  class ProductPage extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.initGallery();
      this.initSticky();
      this.addEventListener('change', (event) => this.onOptionChange(event));
      this.addEventListener('click', (event) => this.onClick(event));
      if (!ProductPage.popstateBound) {
        ProductPage.popstateBound = true;
        window.addEventListener('popstate', () => window.location.reload());
      }
    }

    disconnectedCallback() {
      this.stickyObserver?.disconnect();
    }

    /* Gallery: scroll-snap track with thumbs, arrows and dots. */
    initGallery() {
      this.track = $('[data-gallery-track]', this);
      if (!this.track) return;
      this.slides = $$('.pdp__slide', this.track);
      this.thumbs = $$('.pdp__thumb', this);
      this.dots = $$('[data-gallery-dot]', this);
      this.index = 0;

      let frame;
      this.track.addEventListener(
        'scroll',
        () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => this.setActive(Math.round(this.track.scrollLeft / this.track.clientWidth)));
        },
        { passive: true }
      );
    }

    goTo(index, smooth = true) {
      if (!this.slides?.length) return;
      const target = (index + this.slides.length) % this.slides.length;
      this.track.scrollTo({ left: target * this.track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      this.setActive(target);
    }

    setActive(index) {
      if (index === this.index && this.thumbs[index]?.classList.contains('is-active')) return;
      this.index = index;
      this.thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      const thumb = this.thumbs[index];
      const list = thumb?.parentElement;
      if (list) list.scrollTo({ left: thumb.offsetLeft - list.offsetLeft - list.clientWidth / 3, behavior: 'smooth' });
    }

    initSticky() {
      const bar = $('[data-sticky-atc]', this);
      const button = $('[data-atc]', this);
      if (!bar || !button) return;
      this.stickyObserver = new IntersectionObserver(([entry]) => {
        const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', passed);
        bar.setAttribute('aria-hidden', String(!passed));
      });
      this.stickyObserver.observe(button);
    }

    onClick(event) {
      if (event.target.closest('[data-gallery-prev]')) return this.goTo(this.index - 1);
      if (event.target.closest('[data-gallery-next]')) return this.goTo(this.index + 1);

      const thumb = event.target.closest('[data-gallery-thumb]');
      if (thumb) return this.goTo(Number(thumb.dataset.galleryThumb));

      const zoom = event.target.closest('[data-zoom]');
      const lightbox = $('[data-lightbox]', this);
      if (zoom && lightbox?.showModal) {
        $('[data-lightbox-image]', lightbox).src = zoom.dataset.zoom;
        lightbox.showModal();
        return;
      }
      if (lightbox?.open && event.target.closest('[data-lightbox-close], [data-lightbox-image]')) return lightbox.close();

      const sibling = event.target.closest('[data-sibling-link]');
      if (sibling && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
        event.preventDefault();
        if (sibling.getAttribute('aria-current') === 'true') return;
        this.swapProduct(sibling.href);
      }
    }

    /* Sibling products: replace the whole section and update the URL. */
    async swapProduct(url) {
      this.classList.add('is-loading');
      try {
        const target = new URL(url, window.location.origin);
        target.searchParams.set('section_id', this.sectionId);
        const res = await fetch(target);
        if (!res.ok) throw new Error('fetch');
        const fresh = $('product-page', parseHTML(await res.text()));
        if (!fresh) throw new Error('markup');
        const scrollY = window.scrollY;
        this.replaceWith(fresh);
        window.scrollTo(0, scrollY);
        history.pushState({}, '', url);
        if (fresh.dataset.productTitle) document.title = document.title.replace(this.dataset.productTitle, fresh.dataset.productTitle);
        document.dispatchEvent(new CustomEvent('product:changed', { detail: { url } }));
      } catch (error) {
        window.location.href = url;
      }
    }

    /* Native variants: re-render the info column for the chosen variant. */
    async onOptionChange(event) {
      const picker = event.target.closest('[data-variant-picker]');
      if (!picker) return;
      const variants = JSON.parse($('[data-variants]', picker).textContent);
      const chosen = $$('fieldset', picker).map((group) => $('input:checked', group)?.value);
      const variant = variants.find((item) => item.options.every((value, i) => value === chosen[i]));
      const info = $('[data-product-info]', this);

      if (!variant) {
        $$('[data-atc], .sticky-atc__btn', this).forEach((el) => {
          el.disabled = true;
          $('span', el).textContent = theme.strings.unavailable;
        });
        return;
      }

      this.classList.add('is-loading');
      try {
        const url = `${this.dataset.productUrl}?variant=${variant.id}`;
        const res = await fetch(`${url}&section_id=${this.sectionId}`);
        const fresh = $('product-page', parseHTML(await res.text()));
        const focusId = document.activeElement?.id;
        info.innerHTML = $('[data-product-info]', fresh).innerHTML;
        const sticky = $('[data-sticky-atc]', this);
        const freshSticky = $('[data-sticky-atc]', fresh);
        if (sticky && freshSticky) $('.sticky-atc__inner', sticky).innerHTML = $('.sticky-atc__inner', freshSticky).innerHTML;
        history.replaceState({}, '', url);
        if (focusId) document.getElementById(focusId)?.focus();
        this.stickyObserver?.disconnect();
        this.initSticky();
        if (variant.media) {
          const index = this.slides.findIndex((slide) => slide.dataset.mediaId === String(variant.media));
          if (index > -1) this.goTo(index);
        }
      } finally {
        this.classList.remove('is-loading');
      }
    }
  }
  customElements.define('product-page', ProductPage);

  class ProductVideos extends HTMLElement {
    connectedCallback() {
      this.modal = $('[data-video-modal]', this);
      this.previews = $$('.pdp-videos__item video', this);
      this.autoplay = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(({ target, isIntersecting }) => {
          if (isIntersecting && this.autoplay && !this.modal?.open) target.play().catch(() => {});
          else target.pause();
        });
      }, { threshold: 0.25 });
      this.previews.forEach((video) => this.observer.observe(video));
      this.addEventListener('click', this);
      this.modal?.addEventListener('close', this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    handleEvent(event) {
      if (event.type === 'close') {
        $$('video', this.modal).forEach((video) => video.pause());
        if (this.autoplay) this.previews.forEach((video) => video.play().catch(() => {}));
        return;
      }

      const opener = event.target.closest('[data-video-open]');
      if (opener && this.modal?.showModal) {
        this.previews.forEach((video) => video.pause());
        this.modal.showModal();
        const index = Number(opener.dataset.videoOpen);
        $$('li', this.modal).forEach((item, i) => { item.hidden = i !== index; });
        $$('video', this.modal)[index]?.play().catch(() => {});
        return;
      }
      if (event.target.closest('[data-video-close]') || event.target === this.modal) this.modal.close();
    }
  }
  customElements.define('product-videos', ProductVideos);

  class ProductFinder extends HTMLElement {
    connectedCallback() {
      const exclude = this.keywords(this.dataset.exclude);
      this.products = JSON.parse($('[data-finder-products]', this).textContent)
        .map((product) => {
          const text = [product.title, product.type, ...(product.tags || [])].join(' | ').toLowerCase();
          const width = product.title.match(/(\d+)\s*[x×]/i) || text.match(/(\d+)\s*cm/);
          return { ...product, text, width: width ? Number(width[1]) : null };
        })
        .filter((product) => !exclude.some((word) => product.text.includes(word)));

      this.form = $('[data-finder-form]', this);
      this.steps = $$('[data-step]', this);
      this.grid = $('[data-finder-grid]', this);
      this.index = 0;
      this.pageSize = 12;

      // Options that match no product are hidden; tiles without an image borrow one from a matching product.
      $$('input[name="type"]', this).forEach((input) => {
        if (!input.value) return;
        const match = this.products.find((product) => this.keywords(input.value).some((word) => product.text.includes(word)));
        const tile = input.closest('.finder-tile');
        tile.hidden = !match;
        const media = $('[data-finder-tile-media]', tile);
        if (match?.image && media && !media.children.length) media.append(this.image(match.image, 'eager'));
      });
      $$('[data-finder-color]', this).forEach((label) => {
        const names = $('input', label).value.split('|');
        label.hidden = !this.products.some((product) => names.some((name) => product.text.includes(name.trim())));
      });

      this.addEventListener('click', this);
      this.form.addEventListener('input', () => this.updateCount());
      this.form.addEventListener('submit', (event) => event.preventDefault());
      this.show(0);
    }

    keywords(value) {
      return (value || '').toLowerCase().split(',').map((word) => word.trim()).filter(Boolean);
    }

    image(src, loading = 'lazy') {
      const img = document.createElement('img');
      img.loading = loading;
      img.alt = '';
      img.src = src;
      return img;
    }

    answers() {
      const data = new FormData(this.form);
      return { type: data.get('type') || '', width: Number(data.get('width')) || 0, color: data.get('color') || '', budget: data.get('budget') || '' };
    }

    // `skip` lists the answers to ignore, used to find the closest matches when nothing fits.
    match(answers, skip = []) {
      const use = (key) => answers[key] && !skip.includes(key);
      const [limit, amount] = answers.budget.split(':');
      const list = this.products.filter((product) => {
        if (use('type') && !this.keywords(answers.type).some((word) => product.text.includes(word))) return false;
        if (use('color') && !answers.color.split('|').some((name) => product.text.includes(name.trim()))) return false;
        if (use('width') && (!product.width || product.width > answers.width)) return false;
        if (use('budget') && (limit === 'max' ? product.price > Number(amount) : product.price < Number(amount))) return false;
        return true;
      });
      // Widest piece that still fits first, then cheapest.
      if (use('width')) list.sort((a, b) => b.width - a.width || a.price - b.price);
      return list;
    }

    updateCount() {
      const count = this.match(this.answers()).length;
      $('[data-finder-count]', this).innerHTML = `<b>${count}</b> ${count === 1 ? this.dataset.nounOne : this.dataset.nounMany}`;
    }

    show(index) {
      this.index = index;
      const total = this.steps.length;
      this.steps.forEach((step, i) => step.classList.toggle('is-active', i === index));
      $('[data-finder-step-name]', this).innerHTML = `<b>Stap ${index + 1} van ${total}</b> · ${this.steps[index].dataset.label}`;
      const progress = $('[data-finder-progress]', this);
      progress.style.setProperty('--finder-progress', (index + 1) / total);
      progress.setAttribute('aria-valuemax', total);
      progress.setAttribute('aria-valuenow', index + 1);
      $('[data-finder-back]', this).hidden = index === 0;
      const next = $('[data-finder-next]', this);
      next.textContent = index === total - 1 ? next.dataset.finish : next.dataset.next;
      this.updateCount();
    }

    showResults() {
      const answers = this.answers();
      let list = this.match(answers);
      const exact = list.length > 0;
      for (const skip of [['budget'], ['budget', 'color'], ['budget', 'color', 'width'], ['budget', 'color', 'width', 'type']]) {
        if (list.length) break;
        list = this.match(answers, skip);
      }
      this.results = list;
      this.shown = 0;
      this.grid.replaceChildren();
      $('[data-finder-note]', this).hidden = exact;
      this.renderMore();
      $('[data-finder-quiz]', this).hidden = true;
      $('[data-finder-results]', this).hidden = false;
      $('[data-finder-results-title]', this).focus({ preventScroll: true });
      this.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    renderMore() {
      this.results.slice(this.shown, this.shown + this.pageSize).forEach((product) => this.grid.append(this.card(product)));
      this.shown = Math.min(this.shown + this.pageSize, this.results.length);
      $('[data-finder-more]', this).hidden = this.shown >= this.results.length;
    }

    card(product) {
      const el = (tag, className, text) => {
        const node = document.createElement(tag);
        if (className) node.className = className;
        if (text) node.textContent = text;
        return node;
      };
      const item = el('li');
      const card = el('article', 'product-card');
      const wrap = el('div', 'product-card__media-wrap');
      const media = el('a', 'product-card__media');
      media.href = product.url;
      media.tabIndex = -1;
      media.setAttribute('aria-label', product.title);
      if (product.image) {
        const img = this.image(product.image);
        img.className = 'product-card__img';
        media.append(img);
      }
      wrap.append(media);

      const content = el('div', 'product-card__content');
      const title = el('a', 'product-card__title', product.title);
      title.href = product.url;
      const price = el('span', product.compareText ? 'price price--sale' : 'price');
      if (product.compareText) price.append(el('s', 'price__compare', product.compareText));
      price.append(el('span', 'price__current', product.priceText));
      const priceWrap = el('div', 'product-card__price');
      priceWrap.append(price);
      content.append(title, priceWrap);

      card.append(wrap, content);
      item.append(card);
      return item;
    }

    handleEvent(event) {
      const width = event.target.closest('[data-finder-width]');
      if (width) {
        this.form.elements.width.value = width.dataset.finderWidth;
        return this.updateCount();
      }
      if (event.target.closest('[data-finder-next]')) return this.index === this.steps.length - 1 ? this.showResults() : this.show(this.index + 1);
      if (event.target.closest('[data-finder-back]')) return this.show(this.index - 1);
      if (event.target.closest('[data-finder-more]')) return this.renderMore();
      if (event.target.closest('[data-finder-restart]')) {
        $('[data-finder-results]', this).hidden = true;
        $('[data-finder-quiz]', this).hidden = false;
        this.show(0);
      }
    }
  }
  customElements.define('product-finder', ProductFinder);

  // Live "Nu open" / "Nu gesloten" from opening hours: seven entries, Monday to Sunday, separated by "|".
  class OpeningStatus extends HTMLElement {
    connectedCallback() {
      const toMinutes = (time) => Number(time.slice(0, -3)) * 60 + Number(time.slice(-2));
      this.days = (this.getAttribute('hours') || '').split('|').map((line) => {
        const times = line.match(/\d{1,2}:\d{2}/g) || [];
        const slots = [];
        for (let i = 0; i + 1 < times.length; i += 2) slots.push([toMinutes(times[i]), toMinutes(times[i + 1])]);
        return slots;
      });
      if (this.days.length !== 7) return;
      this.update();
      this.timer = setInterval(() => this.update(), 30000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    update() {
      const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
      const get = (type) => parts.find((part) => part.type === type).value;
      const today = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].indexOf(get('weekday'));
      const now = Number(get('hour')) * 60 + Number(get('minute'));
      const current = this.days[today].find(([from, to]) => now >= from && now < to);

      this.classList.toggle('is-open', Boolean(current));
      this.replaceChildren();
      const dot = document.createElement('i');
      const label = document.createElement('b');
      label.textContent = current ? 'Nu open' : 'Nu gesloten';
      this.append(dot, label);
      this.hidden = false;
    }
  }
  customElements.define('opening-status', OpeningStatus);

  // Avatar stack that keeps sliding one photo to the left; the names in the text follow the first two photos.
  class FansTicker extends HTMLElement {
    connectedCallback() {
      this.track = $('[data-fans-track]', this);
      if (!this.track || !this.hasAttribute('data-rotate') || this.track.children.length < 4) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.timer = setInterval(() => this.next(), 2800);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    next() {
      const first = this.track.firstElementChild;
      const step = this.track.children[1].offsetLeft - first.offsetLeft;
      this.track.style.transition = 'transform 0.6s cubic-bezier(0.22, 0.61, 0.36, 1)';
      this.track.style.transform = `translateX(${-step}px)`;
      this.track.addEventListener('transitionend', () => {
        this.track.style.transition = 'none';
        this.track.append(first);
        this.track.style.transform = '';
        if (this.hasAttribute('data-rotate-names')) this.updateNames();
      }, { once: true });
    }

    updateNames() {
      const names = Array.from(this.track.children).slice(0, 2).map((avatar) => avatar.dataset.name);
      const targets = $$('[data-fans-name]', this);
      if (targets.length !== names.length || names.some((name) => !name)) return;
      targets.forEach((target, i) => { target.textContent = names[i]; });
    }
  }
  customElements.define('fans-ticker', FansTicker);

  /* Product recommendations ---------------------------------------------- */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.children.length || !this.dataset.url) return;
      new IntersectionObserver(
        ([entry], observer) => {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          fetch(this.dataset.url)
            .then((res) => res.text())
            .then((html) => {
              const fresh = $('product-recommendations', parseHTML(html));
              if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
              else this.hidden = true;
            })
            .catch(() => (this.hidden = true));
        },
        { rootMargin: '0px 0px 600px 0px' }
      ).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  /* Collection: AJAX filters, sorting, pagination ------------------------- */
  class MainCollection extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.addEventListener('change', (event) => {
        if (event.target.closest('[data-filters-form]')) this.submitFilters();
      });
      this.addEventListener('submit', (event) => {
        if (!event.target.closest('[data-filters-form]')) return;
        event.preventDefault();
        this.submitFilters();
      });
      this.addEventListener('click', (event) => this.onClick(event));
      window.addEventListener('popstate', () => this.load(window.location.href, false));
    }

    onClick(event) {
      const sort = event.target.closest('[data-sort]');
      if (sort) {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.dataset.sort);
        url.searchParams.delete('page');
        return this.load(url.toString());
      }

      if (event.target.closest('[data-filters-toggle]')) {
        const form = $('[data-filters-form]', this);
        const open = form.classList.toggle('is-open');
        document.body.classList.toggle('is-locked', open);
        return;
      }

      const more = event.target.closest('[data-load-more]');
      if (more) {
        event.preventDefault();
        return this.loadMore(more);
      }

      const link = event.target.closest('[data-ajax-link]');
      if (link) {
        event.preventDefault();
        this.load(link.href);
      }
    }

    submitFilters() {
      const form = $('[data-filters-form]', this);
      const params = new URLSearchParams();
      new FormData(form).forEach((value, key) => value !== '' && params.append(key, value));
      const query = params.toString();
      this.load(`${window.location.pathname}${query ? `?${query}` : ''}`);
    }

    async fetchSection(url) {
      const target = new URL(url, window.location.origin);
      target.searchParams.set('section_id', this.sectionId);
      const res = await fetch(target);
      if (!res.ok) throw new Error('fetch');
      return $('main-collection', parseHTML(await res.text()));
    }

    async load(url, push = true) {
      const content = $('[data-collection-content]', this);
      const filtersOpen = $('[data-filters-form]', this)?.classList.contains('is-open');
      const openFilter = $$('details.filter', this).findIndex((details) => details.open);
      this.classList.add('is-loading');
      try {
        const fresh = await this.fetchSection(url);
        content.innerHTML = $('[data-collection-content]', fresh).innerHTML;
        if (push) history.pushState({}, '', url);
        if (filtersOpen) $('[data-filters-form]', this)?.classList.add('is-open');
        else if (openFilter > -1 && !$$('details.filter', this)[openFilter]?.classList.contains('filter--sort')) $$('details.filter', this)[openFilter]?.setAttribute('open', '');
      } catch (error) {
        window.location.href = url;
      } finally {
        this.classList.remove('is-loading');
      }
    }

    async loadMore(link) {
      link.classList.add('is-loading');
      try {
        const fresh = await this.fetchSection(link.href);
        $('[data-collection-grid]', this).append(...$('[data-collection-grid]', fresh).children);
        const pagination = $('[data-pagination]', this);
        const freshPagination = $('[data-pagination]', fresh);
        if (freshPagination) pagination.innerHTML = freshPagination.innerHTML;
        else pagination.remove();
      } catch (error) {
        window.location.href = link.href;
      }
    }
  }
  customElements.define('main-collection', MainCollection);

  /* Pre-order: weeks until the delivery date ------------------------------ */
  function updateDeliveryWeeks(root = document) {
    $$('[data-delivery-date]', root).forEach((el) => {
      const [y, mo, d] = el.dataset.deliveryDate.split('-').map(Number);
      const diff = new Date(y, mo - 1, d).getTime() - Date.now();
      if (!(diff > 0)) return;
      const weeks = Math.ceil(diff / 6048e5);
      const count = $('[data-weeks-left]', el);
      const word = $('[data-weeks-word]', el);
      if (count) count.textContent = weeks;
      if (word) word.textContent = weeks === 1 ? word.dataset.one : word.dataset.other;
    });
  }
  updateDeliveryWeeks();
  document.addEventListener('product:changed', () => updateDeliveryWeeks());

  /* SEO text: collapsed with a read-more toggle --------------------------- */
  class SeoText extends HTMLElement {
    connectedCallback() {
      const content = $('[data-seo-content]', this);
      const toggle = $('[data-seo-toggle]', this);
      const label = $('[data-seo-label]', this);
      const limit = parseFloat(getComputedStyle(this).getPropertyValue('--seo-collapsed')) || 220;
      if (!content || !toggle) return;
      if ($('[data-seo-more]', this)) this.classList.add('has-more');
      else if (content.scrollHeight <= limit + 60) return;
      this.classList.add('is-collapsible');
      toggle.hidden = false;
      toggle.addEventListener('click', () => {
        const open = this.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
        label.textContent = open ? label.dataset.less : label.dataset.more;
        if (!open) this.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
    }
  }
  customElements.define('seo-text', SeoText);

  /* Open the side cart when arriving with ?cart=open (the /cart page sends
     visitors here, so there is no separate cart step). */
  function openCartFromUrl() {
    const url = new URL(window.location.href);
    if (url.searchParams.get('cart') !== 'open' || !cart.drawer) return;
    url.searchParams.delete('cart');
    history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    cart.drawer.open();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openCartFromUrl);
  else openCartFromUrl();

  /* Boot ----------------------------------------------------------------- */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHeader);
  else initHeader();
})();
